import { gsap } from "gsap";
import jQuery, { data } from "jquery";
import { PageHandler } from './PageHandler';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import moment from "moment";
import Chart from 'chart.js/auto';
import { Utils } from "../misc/Utils";
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import ExcelJS from 'exceljs';        // default import
export class PVOutputPageHandler extends PageHandler {
	constructor(id) {
		super(id);
		this.data = { 'ti-table': [], 'pv-output-table': [], 'thermal-table': [] };
		this.fields = {};
		this.latlngChanged = false;
		this.didPVOutputAnalysis = false;
		this.didThermalAnalysis = false;

		Chart.defaults.font.family = "'Manrope', 'Arial', 'Helvetica', sans-serif"
		Chart.defaults.font.size = 14;

		function getCookie(name) {
			var value = "; " + document.cookie;
			var parts = value.split("; " + name + "=");
			if (parts.length === 2) {
				return parts.pop().split(";").shift();
			}
			return null;
		}

		fetch('https://bipv-city.gr:8443/api/csrf', {
			credentials: 'include' // important: include cookies
		});

		jQuery.ajaxSetup({
			beforeSend: function (xhr, settings) {
				var csrfSafeMethod = /^(GET|HEAD|OPTIONS|TRACE)$/i.test(settings.type);
				if (!csrfSafeMethod) {
					xhr.setRequestHeader("X-CSRFToken", getCookie("csrftoken"));
				}
			}
		});
	}

	showError(text) {
		jQuery('.form-status').text(text);
		jQuery('.form-status').addClass('error')
	}

	hideError() {
		jQuery('.form-status').text('');
		jQuery('.form-status').removeClass('error')
	}

	ajax() {

	}

	static autoWidth(worksheet, rows) {
		if (!rows || !rows.length) return;

		const columnCount = rows[0].length;
		const columnWidths = new Array(columnCount).fill(10);

		rows.forEach(row => {
			row.forEach((value, i) => {
				const text = value == null ? "" : String(value);
				columnWidths[i] = Math.max(columnWidths[i], text.length + 10);
			});
		});

		worksheet.columns = columnWidths.map(width => ({ width }));
	}

	static styleMergedRow(ws, rowNumber) {
		const cell = ws.getCell(`A${rowNumber}`);
		cell.font = { bold: true, size: 12 };
		cell.fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'EAEAEA' }
		};
	}

	static styleRowRange(ws, rowNumber, startCol, endCol, aux) {
		ws.getRow(rowNumber).height = 40;
		for (let col = startCol; col <= endCol; col++) {
			const cell = ws.getCell(rowNumber, col);
			cell.font = { bold: true, size: 12 };
			cell.fill = {
				type: 'pattern',
				pattern: 'solid',
				fgColor: { argb: aux ? 'EAEAEA' : 'B7DEE8' }
			};
		}
	}

	generateInfoExcelJSWorksheet(workbook) {
		let analyses = "Total Irradiance";
		let pvParameters = [["", ""]];
		let thermalParameters = [["", ""]];

		if (this.fields.didPVOutputAnalysis) {
			analyses += ", PV Output";
			pvParameters = [
				["", ""],
				["PV Output parameters", ""],
				["I_L", this.fields.IL],
				["I_0", this.fields.I0],
				["R_S", this.fields.RS],
				["R_sh", this.fields.Rsh],
				["n", this.fields.n],
				["N_s", this.fields.Ns],
			];
		}

		if (this.fields.didThermalAnalysis) {
			analyses += ", Thermal";
			thermalParameters = [
				["", ""],
				["Thermal Analysis parameters", ""],
				["Thermal transmittance (U)", this.fields.U],
				["Infiltration resistance (ρCpVdot)", this.fields.rhoCpVdot],
				["Heat transfer coefficient (h)", this.fields.h],
				["Capacitance (C)", this.fields.C * (Math.pow(10, 7))],
				["Area window (Aw)", this.fields.Aw],
				["Area roof (Ar)", this.fields.Ar],
				["Area room (Af)", this.fields.Af],
				["Solar heat gain coefficient (SHGC)", this.fields.SHGC],
				["Absorptivity (α)", this.fields.alpha],
				["External convective coeficient (hc)", this.fields.hc],
				["T_m,0 type", this.fields.Tm0type],
				["T_out type", this.fields.Touttype],
				["T_setpoint,summer", this.fields.Tsetpoint_maysep],
				["T_setpoint,winter", this.fields.Tsetpoint_octapr],
			];

			// this.fields.qint.forEach((elem, index) => {
			// 	thermalParameters.push([`q_int,${index}:`, elem]);
			// });
		}

		let rows = [
			["Location info", ""],
			["Name", this.fields.location],
			["Latitude", this.fields.latitude],
			["Longitude", this.fields.longitude],
			["Altitude", this.fields.altitude],
			["", ""],
			["PV info", ""],
			["Length", this.fields.L],
			["Width", this.fields.K],
			["Height", this.fields.H],
			["Area", String(this.fields.L * this.fields.K)],
			["Elevation", this.fields.theta],
			["Tilt angle", this.fields.tilt],
			["Azimuth", this.fields.azimuth],
			["", ""],
			["Analysis info", ""],
			["Method", window.tiMethod],
			[
				"Date range",
				`${this.fields.dateRangeStart.format("DD/MM/YYYY")} - ${this.fields.dateRangeEnd.format("DD/MM/YYYY")}`
			],
			["Analyses", analyses]
		];

		if (this.fields.didPVOutputAnalysis)
			rows.push(...pvParameters) 

		if (this.fields.didThermalAnalysis)
			rows.push(...thermalParameters) 

		const ws = workbook.addWorksheet("General Info");
		ws.addRows(rows);
		PVOutputPageHandler.autoWidth(ws, rows);

		let styledMergedRows = [1, 7, 16];

		if (this.fields.didPVOutputAnalysis)
			styledMergedRows.push(21)

		if (this.fields.didThermalAnalysis)
		{
			if (this.fields.didPVOutputAnalysis)
				styledMergedRows.push(29)
			else
				styledMergedRows.push(21)
		}

		styledMergedRows.forEach((value, index) => {
			ws.mergeCells(value, 1, value, 2);
			PVOutputPageHandler.styleMergedRow(ws, value);
			ws.getCell("A"+value).alignment = { vertical: 'middle' };
			ws.getRow(value).height = 40;
		})

		ws.eachRow((row) => {
			row.eachCell((cell) => {
				cell.border = {
					top: {style:'thin'},
					left: {style:'thin'},
					bottom: {style:'thin'},
					right: {style:'thin'}
				}
			});
		});

		return ws;
	}

	generateAnalysisExcelJSWorksheet(workbook, id, sheetName) {
		let { columns, data, index } = this.data[id];

		columns = columns.map((item) => {
			return PVOutputPageHandler.replaceFromArrayReverse(item.replaceAll(" ", "_"));
		});

		const rows = [
			["Date", "Hour", "Minute", ...columns],
			...data.map((row, i) => { 
				const [datePart, timePart] = index[i].split(", ");
				const [day, month, year] = datePart.split("/").map(Number);
				const [hour, minute] = timePart.split(":").map(Number);

				return [`${day}/${month}/${year}`, `${hour}`, `${minute}`, ...row]
			})
		];

		const ws = workbook.addWorksheet(sheetName);
		ws.addRows(rows);

		PVOutputPageHandler.autoWidth(ws, rows);

		if (id == "ti-table")
		{
			PVOutputPageHandler.styleRowRange(ws, 1, 1, 3, true);
			PVOutputPageHandler.styleRowRange(ws, 1, 4, 8, false);
			PVOutputPageHandler.styleRowRange(ws, 1, 9, 15, true);
		}
		else if (id == "pv-output-table")
		{
			PVOutputPageHandler.styleRowRange(ws, 1, 1, 3, true);
			PVOutputPageHandler.styleRowRange(ws, 1, 4, 5, false);
		}
		else if (id == "thermal-table")
		{
			PVOutputPageHandler.styleRowRange(ws, 1, 1, 11, true);
			PVOutputPageHandler.styleRowRange(ws, 1, 12, 14, false);
		}

		ws.eachRow((row) => {
			row.eachCell((cell) => {
				cell.alignment = { horizontal: 'center', vertical: 'middle' };
				cell.border = {
					top: {style:'thin'},
					left: {style:'thin'},
					bottom: {style:'thin'},
					right: {style:'thin'}
				}
			});
		});

		return ws;
	}

	async downloadExcel() {
		const workbook = new ExcelJS.Workbook();

		this.generateInfoExcelJSWorksheet(workbook);
		this.generateAnalysisExcelJSWorksheet(workbook, "ti-table", "Total Irradiance");

		if (this.fields.didPVOutputAnalysis)
			this.generateAnalysisExcelJSWorksheet(workbook, "pv-output-table", "PV Output");

		if (this.fields.didThermalAnalysis)
			this.generateAnalysisExcelJSWorksheet(workbook, "thermal-table", "Thermal Analysis");

		const buffer = await workbook.xlsx.writeBuffer();
		const blob = new Blob(
			[buffer],
			{ type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }
		);

		const url = URL.createObjectURL(blob);
		const a = document.createElement("a");

		a.href = url;
		a.download = `bipv-city-${window.tiMethod}-${this.fields.dateRangeStart.format("DDMMYYYY")}-${this.fields.dateRangeEnd.format("DDMMYYYY")}_${this.fields.tilt}_${this.fields.azimuth}.xlsx`;
		a.click();

		URL.revokeObjectURL(url);
	}


	events() {
		var _this = this;
		/* Tab selection */
		jQuery('body').on('click', '.section__pv-analysis-tab:not(.active):not(.disabled)', function() {
			var view = jQuery(this).data('tab')
			jQuery('.section__pv-analysis-tab.active').removeClass('active')
			jQuery(this).addClass('active')
			_this.changeTab(view);
		})

		const numInputs = document.querySelectorAll('input[type=number][required]')
		numInputs.forEach(function(input) {
			const def = input.setAttribute('data-default', input.value);
			input.addEventListener('input', function(e) {
				if (e.target.value == '')
					e.target.value = input.getAttribute('data-default');
			})
		})

		/* On click qint = "Total" (thermal params) */
		// window.qintValue = "total"
		// jQuery('#thermal-qint-type-qint-total').on('click', function() {
		// 	window.qintValue = "total"
		// 	gsap.set('.section__settings__group--qint-components', { display: 'none' })
		// 	gsap.set('.section__settings__group--qint-total', { display: 'grid' })
		// })

		// /* On click qint = "Components" (thermal params) */
		// jQuery('#thermal-qint-type-qint-components').on('click', function() {
		// 	window.qintValue = "components"
		// 	gsap.set('.section__settings__group--qint-components', { display: 'grid' })
		// 	gsap.set('.section__settings__group--qint-total', { display: 'none' })
		// })
		
		/* On click "Graph" */
		jQuery('body').on('click', '.result-control__selection[data-view]', function() {
			jQuery(this).siblings('.result-control__selection[data-view]')
				.removeClass('result-control__selection--selected')
			jQuery(this)
				.addClass('result-control__selection--selected')

			var item = jQuery(this).attr('data-view')
			if (jQuery(`#${item}`).is('table'))
				gsap.set(jQuery(`#${item}`), { display: 'table' })
			else
				gsap.set(jQuery(`#${item}`), { display: 'block' })
			gsap.set(jQuery(`#${item}`).siblings(), { display: 'none' })
		})

		const XLSX = require("xlsx");

		function toCSV(obj) {
			const { columns, data, index } = obj;

			// header
			const header = ["Timestamp", ...columns].join(",");

			// rows
			const rows = data.map((row, i) => [index[i], ...row].join(","));

			return [header, ...rows].join("\n");
		}

		jQuery('body').on('click', '.section__pv-analysis-right .download-btn', function() {
			_this.downloadExcel();
		});

		jQuery('#thermal-Tout-type-Tsolout').on('click', function(e) {
			jQuery('#thermal-Tout-type-Tout').attr('checked', false)
			jQuery(e.target).attr('checked', true)
		})

		jQuery('#thermal-Tout-type-Tout').on('click', function(e) {
			jQuery('#thermal-Tout-type-Tsolout').attr('checked', false)
			jQuery(e.target).attr('checked', true)
		})

		jQuery('#thermal-Tm0-type-custom').on('click', function(e) {
			gsap.set('.section__settings--thermal-Tm0-custom', { display: 'block' })
			gsap.set('.section__settings--thermal-Tm0-type', { marginBottom: 0 })
			jQuery('#thermal-Tm0-type-Tout').attr('checked', false)
			jQuery('#thermal-Tm0-type-fixed').attr('checked', false)
			jQuery(e.target).attr('checked', true)
		})

		jQuery('#thermal-Tm0-type-fixed').on('click', function(e) {
			jQuery('#thermal-Tm0-type-Tout').attr('checked', false)
			jQuery('#thermal-Tm0-type-custom').attr('checked', false)
			jQuery(e.target).attr('checked', true)
		})

		jQuery('#thermal-Tm0-type-Tout').on('click', function(e) {
			jQuery('#thermal-Tm0-type-fixed').attr('checked', false)
			jQuery('#thermal-Tm0-type-custom').attr('checked', false)
			jQuery(e.target).attr('checked', true)
		})

		jQuery('#thermal-Tm0-type-fixed, #thermal-Tm0-type-Tout').on('click', function() {
			gsap.set('.section__settings--thermal-Tm0-custom', { display: 'none' })
			gsap.set('.section__settings--thermal-Tm0-type', { clearProps: true })
		})
	}

	/* Updates CSS variables related to the illustration, according to the field values */
	updateIllustrationParameters() {
		var r = document.querySelector(':root');
		r.style.setProperty('--illustration-beta', document.querySelector('#input-basic-tilt').value + 'deg');
		r.style.setProperty('--illustration-theta', document.querySelector('#input-basic-theta').value + 'deg');
		r.style.setProperty('--illustration-L', document.querySelector('#input-basic-L').value * 4 + 'px');
		r.style.setProperty('--illustration-K', document.querySelector('#input-basic-K').value * 4 + 'px');
		r.style.setProperty('--illustration-H', document.querySelector('#input-basic-height').value * 2.5 + 'px');
	}

	/* Updates the illustration according to the CSS variables */
	updateIllustrationLines() {
		const line = document.querySelector('.panel-illustration__Bground-line');
		const beta2 = document.querySelector('.panel-illustration__label.panel-illustration__label--beta-2');
		const panelBC = document.querySelector('.panel-illustration__BC-line');
		const panelAD = document.querySelector('.panel-illustration__AD-line');
		const panelShadow = document.querySelector('.panel-illustration__CD-line');
		const panelStraight = document.querySelector('.panel-illustration__beta-line');
		const L = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--illustration-L'));
		const H = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--illustration-H'));
		const beta = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--illustration-beta'));
		const theta = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--illustration-theta'));
		// const offset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--illustration-offset'));
		const groundHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--illustration-ground-height'));
		const triangleOpp = H + L * Math.sin((beta * Math.PI) / 180);
		const W = H / Math.tan(beta * (Math.PI / 180));
		const diagonal = Math.sqrt(H * H + W * W);
		const BCwidth = H / Math.cos((beta * Math.PI) / 180);
		const ADwidth = triangleOpp / Math.sin((theta) * (Math.PI / 180));

		const tempEl = document.createElement('div');
		tempEl.style.position = 'absolute';
		tempEl.style.visibility = 'hidden';
		tempEl.style.height = 'var(--illustration-offset)'; // apply the variable
		document.body.appendChild(tempEl);

		// Get the resolved height in pixels
		const offset = parseFloat(getComputedStyle(tempEl).height);
		document.body.removeChild(tempEl);

		function getBDx(AB, CD, dist, angleAdeg, angleCdeg) {
			const degToRad = deg => deg * Math.PI / 180;

			const Xa = 0;      // A at (0, H)
			const Xc = dist;    // C at (100, H)

			const angleA = degToRad(angleAdeg);
			const angleC = degToRad(angleCdeg);

			const Bx = Xa + AB * Math.cos(angleA);
			const Dx = Xc + CD * Math.cos(angleC);

			const BDx = Dx - Bx;
			return BDx;
		}

		if (beta <= 0 || beta > 90)
			line.style.display = 'none';
		else
			line.style.display = 'block';

		line.style.width = `${diagonal + 2}px`;
		line.style.left = `${177 + offset - W}px`;

		panelStraight.style.width = `${L * Math.cos((beta * Math.PI) / 180)}px`;
		beta2.style.left = `${((210 + offset - W) > 0) ? (210 + offset - W) : 0}px`;

		panelBC.style.transform = `rotate(${90 - beta}deg)`;
		panelBC.style.width = `${BCwidth}px`;
		const CD = getBDx(BCwidth, ADwidth, L * Math.cos((beta * Math.PI) / 180), 90 - beta, theta);

		panelShadow.style.width = `${CD}px`;
		panelShadow.style.left = `${180 + offset + H*Math.tan((beta * Math.PI) / 180)}px`;

		panelAD.style.left = `${180 + offset + L * Math.cos((beta * Math.PI) / 180)}px`;
		panelAD.style.bottom = `${groundHeight + triangleOpp}px`;
		panelAD.style.transform = `rotate(${theta}deg)`;
		panelAD.style.width = `${ADwidth}px`;
	}

	transitions() {
		
	}

	/* Sends an AJAX request to autocomplete the city */
	doAjaxCheckCity(callback) {
		var _this = this;
		jQuery.ajax({
			url: `${bipv_script_data.ajax_url}`, // The URL to upload the file
			type: 'POST',
			data: {
				'query': _this.fields.cityQuery,
				'action': 'checkcity',
				'_ajax_nonce_checkcity': bipv_script_data.nonce_checkcity
			},
			success: function(response) {
				// console.log(response)
				if (response.success)
				{
					callback(response.data);
					return;
				}
			},
			error: function(jqXHR, textStatus, errorThrown) {
				console.log(textStatus, errorThrown)
			}
		});
	}

	/* Sends the AJAX request for BIPV design (climate, PV, thermal) */
	doAjaxBIPVDesign(callback) {
		var _this = this;
		gsap.set('.section__pv-analysis-right .one-result--ti .return-results-container .loading-screen', {autoAlpha: 1})
		gsap.set('.section__pv-analysis-right .one-result--pvo .return-results-container', {display: 'none'})
		gsap.set('.section__pv-analysis-right .one-result--thermal .return-results-container', {display: 'none'})

		let drs = '1', dre = '1';
		if (window.tiMethod == "pvgis")
		{
			drs = _this.fields.dateRangeStart.format('DD/MM/YYYY')
			dre = _this.fields.dateRangeEnd.format('DD/MM/YYYY')
		}
		else if (window.tiMethod != "pvgis-tmy")
		{
			drs = _this.fields.dateRangeStart.format('MM/DD/YYYY')
			dre = _this.fields.dateRangeEnd.format('MM/DD/YYYY')
		}

		/* Basic data object */
		var dataobj = {
			// 'L': _this.fields.L,
			// 'K': _this.fields.K,
			'tilt': _this.fields.tilt,
			'azimuth': _this.fields.azimuth,
			'dateStart': drs,
			'dateEnd': dre,
			'method': window.tiMethod,
			'outputs': ['total_irradiance']
		};

		if (window.tiMethod != "epw")
		{
			dataobj['latitude'] = _this.fields.latitude;
			dataobj['longitude'] = _this.fields.longitude;
			dataobj['altitude'] = _this.fields.altitude;
			if (jQuery("#input-city").val().length)
				_this.fields.location = jQuery("#input-city").val()
			else
				_this.fields.location = "";
		}
		else // EPW mode simply requires the location
			_this.fields.location = dataobj['location'] = _this.fields.epwLocation;

		if (window.selectedDatabase)
			dataobj['raddatabase'] = window.selectedDatabase;

		/* Add PV Output parameters */
		if (jQuery('form.pv-analysis-form #do-pvoutput').is(':checked'))
			preparePVOutputParams();

		/* Add thermal modeling parameters */
		if (jQuery('form.pv-analysis-form #do-thermalanalysis').is(':checked'))
			prepareThermalParams();

		jQuery.ajax({
			url: `https://dev.bipv-city.gr:8443/api/design`,
			type: 'POST',
			data: JSON.stringify(dataobj),
			dataType: "json",
  			contentType: "application/json",
			xhrFields: {
				withCredentials: true   // important if Django is on a different domain
			},
			success: function(response) {
				if (response.success)
				{
					gsap.set('.section__pv-analysis-right .loading-screen', {autoAlpha: 0})
					callback(response.data);
					return;
				}
			},
			error: function(jqXHR, textStatus, errorThrown) {
				console.log(textStatus, errorThrown)
			}
		});

		function preparePVOutputParams() {
			dataobj['outputs'].push('pv_output');
			let pvoObj = {
				IL:  jQuery('form.pv-analysis-form input[name="pv-IL"]').val(),
				I0:  jQuery('form.pv-analysis-form input[name="pv-I0"]').val(),
				RS:  jQuery('form.pv-analysis-form input[name="pv-RS"]').val(),
				Rsh: jQuery('form.pv-analysis-form input[name="pv-Rsh"]').val(),
				n:   jQuery('form.pv-analysis-form input[name="pv-n"]').val(),
				Ns:  jQuery('form.pv-analysis-form input[name="pv-ns"]').val()
			};
			Object.assign(dataobj, pvoObj);
			Object.assign(_this.fields, pvoObj);
			_this.fields.didPVOutputAnalysis = true;

			gsap.set('.section__pv-analysis-right .one-result--pvo .return-results-container', { display: 'block' });
			gsap.set('.section__pv-analysis-right .one-result--pvo .return-results-container .loading-screen', { autoAlpha: 1 });
		}

		function prepareThermalParams() {
			dataobj['outputs'].push('thermal');
			// let qint_arr = [];
			// if (window.qintValue == "total")
			// {
			// 	for (let i = 1; i <= 24; i++)
			// 		qint_arr[i-1] = jQuery(`form.pv-analysis-form input[name="thermal-qint-${i}"]`).val()
			// }
			// else
			// {
			// 	for (let i = 1; i <= 24; i++)
			// 		qint_arr[i-1] = String(
			// 			  parseFloat(jQuery(`form.pv-analysis-form input[name="thermal-qint-occ-${i}"]`).val()) * 10
			// 			+ parseFloat(jQuery(`form.pv-analysis-form input[name="thermal-qint-eq-${i}"]`).val()) * 7
			// 			+ parseFloat(jQuery(`form.pv-analysis-form input[name="thermal-qint-light-${i}"]`).val()) * 6
			// 		)
			// }
			let thermalObj = {
				Uw:        jQuery('form.pv-analysis-form input[name="thermal-Uw"]').val(),
				Ur:        jQuery('form.pv-analysis-form input[name="thermal-Ur"]').val(),
				Uwalls:    jQuery('form.pv-analysis-form input[name="thermal-Uwalls"]').val(),
				h:         jQuery('form.pv-analysis-form input[name="thermal-h"]').val(),
				C:         jQuery('form.pv-analysis-form input[name="thermal-C"]').val(),
				rhoCpVdot: jQuery('form.pv-analysis-form input[name="thermal-rhoCpVdot"]').val(),
				Touttype:  jQuery('form.pv-analysis-form input[name="thermal-Tout-type"][checked]').val(),
				Tsetpoint_maysep: jQuery('form.pv-analysis-form input[name="thermal-Tsetpoint_maysep"]').val(),
				Tsetpoint_octapr: jQuery('form.pv-analysis-form input[name="thermal-Tsetpoint_octapr"]').val(),
				alpha:     jQuery('form.pv-analysis-form input[name="thermal-alpha"]').val(),
				SHGC:      jQuery('form.pv-analysis-form input[name="thermal-SHGC"]').val(),
				Awalls:    jQuery('form.pv-analysis-form input[name="thermal-Awalls"]').val(),
				Aw:        jQuery('form.pv-analysis-form input[name="thermal-Aw"]').val(),
				Ar:        jQuery('form.pv-analysis-form input[name="thermal-Ar"]').val(),
				Af:        jQuery('form.pv-analysis-form input[name="thermal-Af"]').val(),
				hc:        jQuery('form.pv-analysis-form input[name="thermal-hc"]').val(),
				Tm0type:   jQuery('form.pv-analysis-form input[name="thermal-Tm0-type"][checked]').val(),
				Tm0val:    jQuery('form.pv-analysis-form input[name="thermal-Tm0-custom"]').val()
				// qint:      qint_arr
			};
			Object.assign(dataobj, thermalObj);
			Object.assign(_this.fields, thermalObj);
			_this.fields.didThermalAnalysis = true;

			gsap.set('.section__pv-analysis-right .one-result--thermal .return-results-container', { display: 'block' });
			gsap.set('.section__pv-analysis-right .one-result--thermal .return-results-container .loading-screen', { autoAlpha: 1 });
		}
	}

	
	formCity() {
		const cache = new Map();
		let debounceTimeout;
		const input = document.getElementById("input-city");
        const suggestions = document.getElementById("suggestions");
        const output = document.getElementById("output");
		var _this = this;

		function displaySuggestions(data) {
			suggestions.innerHTML = "";
			if (data.length > 0) {
				suggestions.style.display = "block";
				data.forEach(location => {
					const div = document.createElement("div");
					div.classList.add("suggestion-item");
					div.textContent = location.city;
					div.addEventListener("click", () => {
						input.value = location.city;
						suggestions.style.display = "none";
						setCoordinates(location);
					});
					suggestions.appendChild(div);
				});
			} else {
				suggestions.style.display = "none";
			}
		}

		function fetchSuggestions() {
			clearTimeout(debounceTimeout);
			debounceTimeout = setTimeout(() => {
				_this.fields.cityQuery = input.value.trim();
				if (!_this.fields.cityQuery) {
					suggestions.style.display = "none";
					return;
				}
				
				if (cache.has(_this.fields.cityQuery)) {
					displaySuggestions(cache.get(_this.fields.cityQuery));
					return;
				}
				_this.doAjaxCheckCity((data) => {
					cache.set(_this.fields.cityQuery, data); // Store results in cache
					displaySuggestions(data);
				});
				
			}, 600);
		}

		function setCoordinates(location) 
		{
            jQuery('#input-latitude').val(location.lat);
            jQuery('#input-longitude').val(location.lng);
			jQuery('.update-map').trigger('click');
        }

        input.addEventListener("input", fetchSuggestions);
        document.addEventListener("click", (e) => {
            if (!input.contains(e.target) && !suggestions.contains(e.target))
                suggestions.style.display = "none";
        });
	}
	
	formLocation() {
        var _this = this;
		if (this.map)
			this.map.remove();

		this.map = L.map('map');
		L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
			attribution: '&copy; OpenStreetMap contributors'
		}).addTo(this.map);

		this.map.setView([37.9708454, 23.722982], 13);

		const customIcon = L.icon({
            iconUrl: '/wp-content/uploads/2025/02/285659_marker_map_icon-e1740040779222.png',
            iconSize: [48, 48],
            iconAnchor: [24, 24],
            popupAnchor: [1, -34]
        });
        
        var marker = L.marker(this.map.getCenter(), {icon: customIcon, draggable: false})
		              .addTo(this.map);
        
        function updateLatLng() {
            var center = _this.map.getCenter();
            marker.setLatLng(center);
           	jQuery('form.pv-analysis-form input[name="latitude"]').val(center.lat.toFixed(6));
           	jQuery('form.pv-analysis-form input[name="longitude"]').val(center.lng.toFixed(6));

			_this.fields.latitude = center.lat.toFixed(6);
			_this.fields.longitude = center.lng.toFixed(6);
			_this.fields.altitude = 100;
        }
        
        this.map.on('move', updateLatLng);
        updateLatLng();

		jQuery(`form.pv-analysis-form input[name="latitude"], 
		        form.pv-analysis-form input[name="longitude"]`).on('input', function() {
			_this.latlngChanged = true;
		})
		
		jQuery(document).on("keypress", 'form.pv-analysis-form', function (e) {
			var code = e.keyCode || e.which;
			if (code == 13) {
				e.preventDefault();
				return false;
			}
		});

		jQuery('form.pv-analysis-form button.update-map').on('click', function() {
			if (_this.latlngChanged)
			{
				jQuery('#input-city').val('');
				_this.latlngChanged = false;
			}
			_this.map.setView([
				parseFloat(jQuery('form.pv-analysis-form input[name="latitude"]').val()), 
				parseFloat(jQuery('form.pv-analysis-form input[name="longitude"]').val())
			], _this.map.getZoom());
		})
	}

	
	formLocation_EPW(lat, lng, alt) {
		var _this = this;
		if (this.map)
			this.map.remove();

		function updateLatLng_EPW(lat, lng, alt) {
			_this.map.setView([lat, lng], 13);
			var center = _this.map.getCenter();
			_this.mapMarker.setLatLng(center);
			jQuery('form.pv-analysis-form input[name="latitude"]').val(center.lat.toFixed(6));
			jQuery('form.pv-analysis-form input[name="longitude"]').val(center.lng.toFixed(6));
			jQuery('form.pv-analysis-form input[name="altitude"]').val(alt);

			_this.fields.latitude = center.lat.toFixed(6);
			_this.fields.longitude = center.lng.toFixed(6);
			_this.fields.altitude = alt;
		}

		const locationForm = document.querySelector('.pv-analysis-form');
		const selectedLoc = document.querySelector('main.pv-analysis .section__settings--location .same-as-selected')

		this.map = L.map('map');
		L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
			attribution: '&copy; OpenStreetMap contributors'
		}).addTo(this.map);

		const customIcon = L.icon({
            iconUrl: '/wp-content/uploads/2025/02/285659_marker_map_icon-e1740040779222.png',
            iconSize: [48, 48],
            iconAnchor: [24, 24],
            popupAnchor: [1, -34]
        });
		this.map.setView([lat, lng], 13);
        this.mapMarker = L.marker(this.map.getCenter(), {icon: customIcon, draggable: false}).addTo(this.map);
        updateLatLng_EPW(lat, lng, alt);
		
		jQuery(document).on("keypress", 'form.pv-analysis-form', function (e) {
			var code = e.keyCode || e.which;
			if (code == 13) {
				e.preventDefault();
				return false;
			}
		});

		window.selectedLocation = selectedLoc.getAttribute('data-value');
		locationForm.querySelector('input[name="location"]').value = window.selectedLocation;
		window.global.initSelect('main.pv-analysis .section__settings--location .custom-select-wrapper', (option) => {
			window.selectedLocation = jQuery(option).data('value');
			let lat = jQuery(option).data('lat')
			let lng = jQuery(option).data('lng')
			let alt = jQuery(option).data('alt')

			locationForm.querySelector('input[name="location"]').value = window.selectedLocation;
			updateLatLng_EPW(lat, lng, alt);
		});
	}


	formDateRange() {
		var _this = this;
		jQuery('#graph-daterange').daterangepicker({
			showDropdowns: true,
			autoApply: true,
			locale: { format: "DD/MM/YYYY" },
			startDate: window.tiMethod == "pvgis" ? "01/01/2023" : moment().format('DD/MM/YYYY'),
			minDate: window.tiMethod == "pvgis" ? "01/01/2005" : `01/01/1970`,
			maxDate: window.tiMethod == "pvgis" ? "31/12/2023" : moment().format('DD/MM/YYYY')
		}, function(start, end, label) {
			_this.fields.dateRangeStart = start;
			_this.fields.dateRangeEnd = end;
		});

		_this.fields.dateRangeStart = jQuery('#graph-daterange').data('daterangepicker').startDate;
		_this.fields.dateRangeEnd = jQuery('#graph-daterange').data('daterangepicker').endDate;
	}

	static replaceFromArray(text)
	{
		let arr = [
			["poa", "POA"],
			["Tm_n+1", "T<sub>m,n+1</sub>"],
			["Tm", "T<sub>m</sub>"],
			["tau", "&tau;"],
			["Tair", "T<sub>air</sub>"],
			["Tout", "T<sub>out</sub>"],
			["Tsol_out", "T<sub>sol-out</sub>"],
			["qHVAC", "q<sub>HVAC</sub>"],
			["qint_n", "q<sub>int,n</sub>"],
			["qrad_int_n", "q<sub>rad,int,n</sub>"],
			['p_mp_ac', "P<sub>mp,ac</sub>"],
			['p_mp_dc', "P<sub>mp,dc</sub>"]
		];
		arr.forEach(element => {
			text = text.replace(element[0], element[1]);
		});

		return text
	}

	static replaceFromArrayReverse(text)
	{
		let arr = [
			["q_sol [W/m2]", "POA_global"],
			["Gb_tilt [W/m2]", "POA_direct"],
			["Gd_tilt [W/m2]", "POA_diffuse"],
			["Gsky_tilt [W/m2]", "POA_sky_diffuse"],
			["Gref [W/m2]", "POA_ground_diffuse"],
			["Tm,n+1 [°C]", "T<sub>m,n+1</sub>"],
			["Tm [°C]", "T<sub>m</sub>"],
			["τ", "&tau;"],
			["Tair [°C]", "T<sub>air</sub>"],
			["Tout [°C]", "T<sub>out</sub>"],
			["Tsol-out [°C]", "T<sub>sol-out</sub>"],
			["qHVAC [W]", "q<sub>HVAC</sub>"],
			["qint,n [W]", "q<sub>int,n</sub>"],
			["qrad,int,n [W]", "q<sub>rad,int,n</sub>"],
			['P_mp (AC) [W]', "P<sub>mp,ac</sub>"],
			['P_mp (DC) [W]', "P<sub>mp,dc</sub>"]
		];
		arr.forEach(element => {
			text = text.replace(element[1], element[0])
		});

		return text
	}

	
	/* Creates a table from the parsed data */
	createTableAndGraph(parsedData, tableID, parent) {
		function parseDDMMTimestamp(s) {
			// "19/11/2024, 00:00" or "19/11/2024 00:00"
			const [datePart, timePartRaw] = s.split(',').map(x => x.trim());
			const timePart = (timePartRaw ?? '').trim();

			const [dd, mm, yyyy] = datePart.split('/').map(Number);
			let hh = 0, min = 0;
			if (timePart) {
				const [h, m] = timePart.split(':').map(Number);
				hh = Number.isFinite(h) ? h : 0;
				min = Number.isFinite(m) ? m : 0;
			}

			// Use UTC to avoid DST surprises when bucketing by month.
			return new Date(Date.UTC(yyyy, mm - 1, dd, hh, min, 0, 0));
		}

		function isAboveMonths(merged, delta) {
			if (!merged || merged.length < 2) return false;
			const first = parseDDMMTimestamp(merged[0][0]);
			const last  = parseDDMMTimestamp(merged[merged.length - 1][0]);

			// "above one month" => more than 1 calendar month boundary, or > ~31 days
			const monthDelta = (last.getUTCFullYear() - first.getUTCFullYear()) * 12
							+ (last.getUTCMonth() - first.getUTCMonth());

			if (monthDelta >= delta) return true;

			const ms = last - first;
			const days = ms / (1000 * 60 * 60 * 24);
			return days > delta * 31;
		}

		function toMonthKey(d) {
			const y = d.getUTCFullYear();
			const m = String(d.getUTCMonth() + 1).padStart(2, '0');
			return `${y}-${m}`; // e.g. "2024-11"
		}

		function aggregateMonthlyAverages(merged, valueIndices) {
			// valueIndices are positions in the row to average (e.g. [1,2,3] or [1] or [9])
			const buckets = new Map(); // key -> { sums: number[], counts: number[] }

			for (const row of merged) {
				const d = parseDDMMTimestamp(row[0]);
				const key = toMonthKey(d);

				if (!buckets.has(key)) {
				buckets.set(key, {
					sums: Array(valueIndices.length).fill(0),
					counts: Array(valueIndices.length).fill(0),
				});
				}

				const b = buckets.get(key);

				valueIndices.forEach((idx, j) => {
				const v = Number(row[idx]);
				if (Number.isFinite(v)) {
					b.sums[j] += v;
					b.counts[j] += 1;
				}
				});
			}

			// sort month keys ascending
			const keys = Array.from(buckets.keys()).sort((a, b) => a.localeCompare(b));

			// build aggregated rows: [label, avg1, avg2, ...]
			return keys.map(key => {
				const b = buckets.get(key);
				const avgs = b.sums.map((sum, j) => (b.counts[j] ? sum / b.counts[j] : null));
				return [key, ...avgs];
			});
		}

		var _this = this;
		let header = ['Datetime'];

		const thead = document.createElement("thead"), 
		      theadRow = document.createElement("tr"),
		      tbody = document.createElement("tbody");
		const table = document.getElementById(tableID);
		
		parsedData.index = parsedData.index.map((element) => {
			const opts = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' };
			return moment.utc(element).format('DD/MM/YYYY, HH:mm');
		})

		if (parsedData.columns && parsedData.columns.length > 0)
		{
			parsedData.columns = parsedData.columns.map((item) => {
				return PVOutputPageHandler.replaceFromArray(item).replaceAll("_", " ");
			})
			header = Array.prototype.concat(header, parsedData.columns);
			header.forEach(element => {
				const th = document.createElement("th");
				jQuery(th).html(element)
				theadRow.appendChild(th);
			});
			thead.appendChild(theadRow);
		}
		else if (parsedData.name)
		{
			parsedData.name = parsedData.name.replaceAll("p_mp", "P<sub>mp</sub>")
			header.push(parsedData.name);
			header.forEach(element => {
				const th = document.createElement("th");
				jQuery(th).html(element)
				theadRow.appendChild(th);
			});
			thead.appendChild(theadRow);
		}
		
		this.data[tableID] = parsedData;

		table.appendChild(thead);
		table.appendChild(tbody);

		/* Chunk loading */
		let loadedLines = 0;
		const CHUNK_SIZE = 19; 
		parent.scrollTop = 0;
		jQuery(parent).off('scroll')

		const merged = parsedData.data.map((row, i) => {
			const values = Array.isArray(row) ? row : [row];
			return [parsedData.index[i], ...values];
		});

		if (tableID == "ti-table" && !this.tiGraph)
		{
			var ctx = document.querySelector('#ti-graph');
			const labels = [];

			var config = {
				type: 'line',
				options: {
					maintainAspectRatio: false,
					layout: {
						padding: 20
					}
				},
				data: {
					labels: labels,
					datasets: [
						{
							label: 'POA Global',
							data: [],
							fill: false,
							borderColor: 'rgb(75, 192, 192)',
							tension: 0.1,
							pointRadius: 0,
							pointHitRadius: 6,
							borderWidth: 1
						},
						{
							label: 'POA Direct',
							data: [],
							fill: false,
							borderColor: 'rgba(75, 89, 192, 1)',
							tension: 0.1,
							pointRadius: 0,
							pointHitRadius: 6,
							borderWidth: 1
						},
						{
							label: 'POA Diffuse',
							data: [],
							fill: false,
							borderColor: 'rgba(192, 75, 75, 1)',
							tension: 0.1,
							pointRadius: 0,
							pointHitRadius: 6,
							borderWidth: 1
						}
					]
				},
			}
			this.tiGraph = new Chart(ctx, config);
			gsap.set(ctx, {display: 'none'})
		}
		else if (tableID == "pv-output-table" && !this.pvOutputGraph)
		{
			var ctx = document.querySelector('#pv-output-graph');
			const labels = [];

			var config = {
				type: 'line',
				data: {
					labels: labels,
					datasets: [{
						label: 'PV Output (AC)',
						data: [],
						fill: false,
						borderColor: 'rgba(75, 89, 192, 1)',
						tension: 0.1,
						pointRadius: 0,
						pointHitRadius: 6,
						borderWidth: 1
					}]
				},
			}
			this.pvOutputGraph = new Chart(ctx, config);
			gsap.set(ctx, {display: 'none'})
		}
		else if (tableID == "thermal-table")
		{
			if (!this.thermalGraphTemps)
			{
				var ctx = document.querySelector('#thermal-graph-temps');
				const labels = [];
				var config = {
					type: 'line',
					data: {
						labels: labels,
						datasets: [
							{
								label: 'Tm,n+1',
								data: [],
								fill: false,
								borderColor: 'rgba(192, 75, 75, 1)',
								tension: 0.1,
								pointRadius: 0,
								pointHitRadius: 6,
								borderWidth: 1
							},
							{
								label: 'Tair',
								data: [],
								fill: false,
								borderColor: 'rgba(75, 89, 192, 1)',
								tension: 0.1,
								pointRadius: 0,
								pointHitRadius: 6,
								borderWidth: 1
							},
						]
					},
				}
				this.thermalGraphTemps = new Chart(ctx, config);
				gsap.set(ctx, {display: 'none'})
			}

			if (!this.thermalGraphqHVAC)
			{
				var ctx = document.querySelector('#thermal-graph-qhvac');
				const labels = [];

				var config = {
					type: 'line',
					data: {
						labels: labels,
						datasets: [
							{
								label: 'qHVAC',
								data: [],
								fill: false,
								borderColor: 'rgba(192, 75, 75, 1)',
								tension: 0.1,
								pointRadius: 0,
								pointHitRadius: 6,
								borderWidth: 1
							}]
					},
				}
				
				this.thermalGraphqHVAC = new Chart(ctx, config);
				
				gsap.set(ctx, {display: 'none'})
			}
		}

		// Decide if we should plot monthly averages
		const monthly = isAboveMonths(merged, 2) && 0;

		// Build table-specific "rowsToPlot"
		let rowsToPlot = merged;

		if (monthly) {
			if (tableID === "ti-table")
				// row[1], row[2], row[3] correspond to your three datasets
				rowsToPlot = aggregateMonthlyAverages(merged, [1, 2, 3]);
			else if (tableID === "pv-output-table")
				// row[1]
				rowsToPlot = aggregateMonthlyAverages(merged, [1]);
			else if (tableID === "thermal-table")
				// row[11]
				rowsToPlot = aggregateMonthlyAverages(merged, [9, 10, 11]);
		}

		function resetChart(chart) {
			chart.data.labels.length = 0;
			chart.data.datasets.forEach(ds => (ds.data.length = 0));
		}

		if (tableID == "ti-table" && _this.tiGraph) resetChart(_this.tiGraph);
		if (tableID == "pv-output-table" && _this.pvOutputGraph) resetChart(_this.pvOutputGraph);
		if (tableID == "thermal-table" && _this.thermalGraphTemps) resetChart(_this.thermalGraphTemps);
		if (tableID == "thermal-table" && _this.thermalGraphqHVAC) resetChart(_this.thermalGraphqHVAC);

		rowsToPlot.forEach(row => {
			if (tableID == "ti-table" && _this.tiGraph) {
				// row[0] is either original timestamp or "YYYY-MM" monthly label
				_this.tiGraph.data.labels.push(row[0]);

				// row[1..3] are the averaged values if monthly, otherwise original
				_this.tiGraph.data.datasets[0].data.push(row[1]);
				_this.tiGraph.data.datasets[1].data.push(row[2]);
				_this.tiGraph.data.datasets[2].data.push(row[3]);

			} else if (tableID == "pv-output-table" && _this.pvOutputGraph) {
				_this.pvOutputGraph.data.labels.push(row[0]);
				_this.pvOutputGraph.data.datasets[0].data.push(row[1]);

			} else if (tableID == "thermal-table") {
				if (_this.thermalGraphqHVAC)
				{
					_this.thermalGraphqHVAC.data.labels.push(row[0]);
					if (monthly)
						_this.thermalGraphqHVAC.data.datasets[0].data.push(row[1]);
					else
						_this.thermalGraphqHVAC.data.datasets[0].data.push(row[11]);
				}
				if (_this.thermalGraphTemps)
				{
					_this.thermalGraphTemps.data.labels.push(row[0]);
					if (monthly)
					{
						_this.thermalGraphTemps.data.datasets[0].data.push(row[1]);
						_this.thermalGraphTemps.data.datasets[1].data.push(row[2]);
					}
					else
					{
						_this.thermalGraphTemps.data.datasets[0].data.push(row[9]);
						_this.thermalGraphTemps.data.datasets[1].data.push(row[10]);
					}
				}
				
			}
		});

		// Don’t forget to update after changes
		if (tableID == "ti-table" && _this.tiGraph) _this.tiGraph.update();
		if (tableID == "pv-output-table" && _this.pvOutputGraph) _this.pvOutputGraph.update();
		if (tableID == "thermal-table" && _this.thermalGraphTemps) _this.thermalGraphTemps.update();
		if (tableID == "thermal-table" && _this.thermalGraphqHVAC) _this.thermalGraphqHVAC.update();
	

		function loadChunk() {
			if (loadedLines < merged.length) {
				
				const nextChunk = merged.slice(loadedLines, loadedLines + CHUNK_SIZE);

				nextChunk.forEach(row => {
					const tr = document.createElement("tr");
					
					
					row.forEach(cell => {
						const td = document.createElement("td");
						td.textContent = cell;
						tr.appendChild(td);
					});
					tbody.appendChild(tr);
				});

				// if (tableID == "ti-table" && _this.tiGraph)
				// 	_this.tiGraph.update();
				// else if (tableID == "pv-output-table" && _this.pvOutputGraph)
				// 	_this.pvOutputGraph.update();
				// else if (tableID == "thermal-table" && _this.thermalGraph)
				// 	_this.thermalGraph.update();
				loadedLines += CHUNK_SIZE;
			}
		}
	
		loadChunk();
		
		jQuery(parent).on('scroll', () => {
			const scrollHeight = parent.scrollHeight;
			const scrollTop = parent.scrollTop;
			const clientHeight = parent.clientHeight;

			if (scrollTop + clientHeight >= scrollHeight - 100) {
				loadChunk();
			}
		});
	}

	
	async calculate({ useEPW = false }) {
		const form = jQuery('form.pv-analysis-form');
		this.fields.tilt = form.find('input[name="basic-tilt"]').val();
		this.fields.azimuth = form.find('input[name="basic-azimuth"]').val();
		this.fields.L = jQuery('form.pv-analysis-form input[name="basic-L"]').val();
		this.fields.K = jQuery('form.pv-analysis-form input[name="basic-K"]').val();
		this.fields.H = jQuery('form.pv-analysis-form input[name="basic-height"]').val();
		this.fields.theta = jQuery('form.pv-analysis-form input[name="basic-theta"]').val();

		if (useEPW) 
		{
			this.fields.epwLocation = form.find('input[name="location"]').val();
			jQuery('#pv-output-table').empty(); // Only clear if EPW (no PV output table)
			jQuery('#thermal-table').empty(); // Only clear if EPW (no PV output table)
		} 
		else 
		{
			// Fetch altitude from Open-Meteo
			const { latitude, longitude } = this.fields;
			try {
				const response = await fetch(`https://api.open-meteo.com/v1/elevation?latitude=${latitude}&longitude=${longitude}`);
				const data = await response.json();
				this.fields.altitude = data.elevation[0].toFixed(2);
			} catch (error) {
				console.error('Error fetching altitude:', error);
				this.fields.altitude = 100;
			}
			form.find('input[name="altitude"]').val(this.fields.altitude);
		}

		document.getElementById("ti-table").innerHTML = "";
		if (this.tiGraph)
		{
			this.tiGraph.destroy();
			this.tiGraph = null;
		}
		gsap.set('.one-result--ti', { display: 'block' });

		document.getElementById("pv-output-table").innerHTML = "";
		if (this.pvOutputGraph)
		{
			this.pvOutputGraph.destroy();
			this.pvOutputGraph = null;
		}
		if (jQuery('form.pv-analysis-form #do-pvoutput').is(':checked')) 
			gsap.set('.one-result--pvo', { display: 'block' });
		else
			gsap.set('.one-result--pvo', { display: 'none' });

		document.getElementById("thermal-table").innerHTML = "";
		if (this.thermalGraphTemps)
		{
			this.thermalGraphTemps.destroy();
			this.thermalGraphTemps = null;
		}
		if (this.thermalGraphqHVAC)
		{
			this.thermalGraphqHVAC.destroy();
			this.thermalGraphqHVAC = null;
		}
		if (jQuery('form.pv-analysis-form #do-thermalanalysis').is(':checked'))
			gsap.set('.one-result--thermal', { display: 'block' });
		else
			gsap.set('.one-result--thermal', { display: 'none' });

		/* Preparation */
		gsap.to('.section__pv-analysis-right__in', { autoAlpha: 1, display: "block" });

		/* AJAX + render */
		this.doAjaxBIPVDesign((data) => {
			const parsedData = data;

			/* Total Irradiance */
			this.renderTotalIrradiance(parsedData);
			
			/* PV Output */
			this.renderPVOutput(parsedData);

			/* Thermal Analysis */
			this.renderThermalAnalysis(parsedData);
		});
	}
	

	renderTotalIrradiance(parsedData) {
		this.createTableAndGraph(
			parsedData['total_irradiance'],
			'ti-table',
			document.querySelector('.one-result--ti .return-results-container .return-results')
		);
		this.showScrollHint('#ti-table', '.one-result--ti .return-results-container');
	}

	renderPVOutput(parsedData) {
		if (jQuery('form.pv-analysis-form #do-pvoutput').is(':checked')) {
			this.createTableAndGraph(
				parsedData['pv_output'],
				'pv-output-table',
				document.querySelector('.one-result--pvo .return-results-container .return-results')
			);
			this.showScrollHint('#pv-output-table', '.one-result--pvo .return-results-container');
		}
	}

	renderThermalAnalysis(parsedData) {
		if (jQuery('form.pv-analysis-form #do-thermalanalysis').is(':checked')) {
			this.createTableAndGraph(
				parsedData['thermal_model'],
				'thermal-table',
				document.querySelector('.one-result--thermal .return-results-container .return-results')
			);
			this.showScrollHint('#thermal-table', '.one-result--thermal .return-results-container');
		}
	}

	showScrollHint(tableSelector, containerSelector) {
		if (jQuery(tableSelector).height() <= jQuery(containerSelector).height()) 
			return;

		const hint = `${containerSelector} .please-scroll`;
		gsap.to(hint, { autoAlpha: 0.9, duration: 0.3 });
		setTimeout(() => {
			gsap.to(hint, { autoAlpha: 0, duration: 0.3 });
		}, 2000);
	}

	formEvents() {
		var _this = this;
		jQuery('form.pv-analysis-form input[type="submit"]').on('click', function(e) {
			e.preventDefault();
			e.stopPropagation();
			jQuery('.result-control__selection[data-view]:nth-child(1)').click();

			_this.calculate({ useEPW: (window.tiMethod == "epw") });
		})

		jQuery('form.pv-analysis-form #do-pvoutput').on('click', function(e) {
			jQuery('main.pv-analysis .section__settings--pv-output-parameters').toggleClass('hidden');
		})

		jQuery('form.pv-analysis-form #do-thermalanalysis').on('click', function(e) {
			jQuery('main.pv-analysis .section__settings--thermal-analysis-parameters').toggleClass('hidden');
		})

		jQuery('main.pv-analysis .section__settings .tooltip').on('click', function(e) {
			e.preventDefault();
			e.stopPropagation();
			jQuery(this).find('.tooltip-text').toggleClass('active');
		})

		jQuery('#input-thermal-Uw').on('input', function() {
			let elem = jQuery('.section__settings--thermal-window-type .select-selected');
			if (jQuery('#input-thermal-Uw').val() != jQuery('#input-thermal-Uw').attr('data-default'))
			{
				if (!window.modifiedOnce)
				{
					window.modifiedOnce = true;
					window.oldValue = elem.text();
					elem.text(elem.text() + ' (*)')
				}
			}
			else
			{
				window.modifiedOnce = false;
				elem.text(window.oldValue)
			}
		})

		window.global.initSelect('main.pv-analysis .section__settings--thermal-window-type .custom-select-wrapper', (option) => {
			document.querySelector('#input-thermal-Uw').value = jQuery(option).data('u-value');
			jQuery('#input-thermal-Uw').attr('data-default', jQuery(option).data('u-value'));
		});
	}


	initPageClearsky() {
		this.formCity();
		this.formLocation();
		this.formDateRange();
		this.formEvents();
		this.formIllustration();
	}

	formIllustration() {
		var _this = this;

		this.updateIllustrationParameters();
		this.updateIllustrationLines();

		jQuery(`form.pv-analysis-form input[name="basic-tilt"], 
		        form.pv-analysis-form input[name="basic-L"],
		        form.pv-analysis-form input[name="basic-K"],
		        form.pv-analysis-form input[name="basic-height"],
		        form.pv-analysis-form input[name="basic-theta"]`).on('input', function() {
			_this.updateIllustrationParameters();
			_this.updateIllustrationLines();
		})

		jQuery(window).on('resize', function() {
			_this.updateIllustrationLines();
		})
	}

	initPageEPW() {
		const selectedLoc = document.querySelector('main.pv-analysis .section__settings--location .same-as-selected')
		let lat = selectedLoc.getAttribute('data-lat')
		let lng = selectedLoc.getAttribute('data-lng')
		let alt = selectedLoc.getAttribute('data-alt')

		this.formLocation_EPW(lat, lng, alt);
		this.formDateRange();
		this.formEvents();
		this.formIllustration();
	}

	/* TODO implement */
	initPageEPWFile() {
		var _this = this;
	}

	initPagePVGIS() {
		this.formCity();
		this.formLocation();
		this.formDateRange();
		this.formEvents();
		this.formIllustration();

		const database = document.querySelector('main.pv-analysis .section__settings--database .same-as-selected')
		window.selectedDatabase = database.getAttribute('data-value');
		window.global.initSelect('main.pv-analysis .section__settings--database .custom-select-wrapper', (option) => {
			window.selectedDatabase = jQuery(option).data('value');
		});
	}

	initPagePVGIS_TMY() {
		this.formCity();
		this.formLocation();
		this.formEvents();
		this.formIllustration();
	}

	init() {
		this.events();
		var _this = this;
		
		if (window.tiMethod == "epw")
			this.initPageEPW();
		else if (window.tiMethod == "pvgis")
			this.initPagePVGIS();
		else if (window.tiMethod == "pvgis-tmy")
			this.initPagePVGIS_TMY();
		else
			this.initPageClearsky();
	}


	destroy() {

	}
}
